// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SBjRw","footer":"styles_footer__111ni","passCodeTooltip":"styles_passCodeTooltip__1r5y5"};